import { useEffect, useState } from "react";
import { producaov2 } from "../../../../../services/apis";

export default function useFetchSurveys({ search, statusID } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [refetchCount, setRefetchCount] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const getData = async () => {
      setLoading(true);

      try {
        const response = await producaov2.get('/admin/surveys', {
          params: {
            page: page + 1,
            limit: rowsPerPage,
            search,
            ...(statusID !== 'all' && {statusID})
          }
        });

        if(isMounted) {
          setData(response.data);
        }
      } catch(error) {
        console.log(error);
      } finally {
        if(isMounted) {
          setLoading(false);
        }
      }
    }

    getData();

    return () => {
      isMounted = false;
    }
  }, [page, rowsPerPage, search, statusID, refetchCount]);

  const changePage = (newPage) => {
    setPage(newPage);
  }

  const changeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    changePage(0);
  }

  const refetch = () => {
    setRefetchCount(prev => prev + 1);
  }

  return {
    data,
    loading,
    error,
    page,
    rowsPerPage,
    changePage,
    changeRowsPerPage,
    refetch
  }
}